// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__AX1CV","button":"styles_button__1_kzq","cancel":"styles_cancel__2SSu9"};